import React from "react";
import ClassNames from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./index.module.scss";

import SentimentVerySatisfiedIcon from "@material-ui/icons/SentimentVerySatisfied";
import SentimentVeryDissatisfiedIcon from "@material-ui/icons/SentimentVeryDissatisfied";
import SentimentNeutralIcon from "@material-ui/icons/SentimentSatisfied";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormControlLabel-root": {
      marginBottom: 0,
      marginRight: "4px",
    },
  },
  iconNeutral: {
    fontSize: "2.5rem",
    color: "#bbb",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: "#ff9c12",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "inherit",
    },
  },
  iconHappy: {
    fontSize: "2.5rem",
    color: "#bbb",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: "#0fc77b",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "inherit",
    },
  },
  iconSad: {
    fontSize: "2.5rem",
    color: "#bbb",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: theme.palette.primary.hover,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "inherit",
    },
  },
  checkedIcon: {
    backgroundColor: "transparent !important",
    color: theme.palette.primary.active,
  },
  checkedIconHappy: {
    backgroundColor: "transparent !important",
    color: "#0fc77b",
  },
  checkedIconNeutral: {
    backgroundColor: "transparent !important",
    color: "#ff9c12",
  },
}));

function HappyMood(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.iconHappy}
      disableRipple
      checkedIcon={
        <SentimentVerySatisfiedIcon className={classes.checkedIconHappy} />
      }
      icon={<SentimentVerySatisfiedIcon />}
      {...props}
    />
  );
}

function SadMood(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.iconSad}
      disableRipple
      checkedIcon={
        <SentimentVeryDissatisfiedIcon className={classes.checkedIcon} />
      }
      icon={<SentimentVeryDissatisfiedIcon />}
      {...props}
    />
  );
}

function NeutralMood(props) {
  const classes = useStyles();

  return (
    <Radio
      className={classes.iconNeutral}
      disableRipple
      checkedIcon={
        <SentimentNeutralIcon className={classes.checkedIconNeutral} />
      }
      icon={<SentimentNeutralIcon />}
      {...props}
    />
  );
}
export default function SatisfactionRating({
  onChange,
  coacheeRating,
  ratingValue,
  isReadOnly,
  ...props
}) {
  const classes = useStyles();

  return (
    <div className={styles.satisfactionRating}>
      <div
        className={ClassNames(styles.satisfactionRatingWrapper, styles.input)}
      >
        {coacheeRating === null || coacheeRating === undefined ? (
          <RadioGroup
            row
            aria-label="emotion"
            name="satisfaction-rating"
            className={classes.root}
            onChange={(event, newValue) => {
              onChange(newValue);
            }}
            {...props}
          >
            <FormControlLabel
              value="1"
              disabled={!!isReadOnly}
              control={
                <HappyMood
                  checked={parseInt(ratingValue) === 1 ? "checked" : ""}
                />
              }
            />
            <FormControlLabel
              value="0"
              disabled={!!isReadOnly}
              control={
                <NeutralMood
                  checked={parseInt(ratingValue) === 0 ? "checked" : ""}
                />
              }
            />
            <FormControlLabel
              value="-1"
              disabled={!!isReadOnly}
              control={
                <SadMood
                  checked={parseInt(ratingValue) === -1 ? "checked" : ""}
                />
              }
            />
          </RadioGroup>
        ) : (
          <RadioGroup
            row
            aria-label={"emotion-" + coacheeRating.toString()}
            name="satisfaction-rating"
            className={classes.root}
            defaultValue={coacheeRating.toString()}
            value={coacheeRating.toString()}
            {...props}
          >
            <FormControlLabel value="1" disabled control={<HappyMood />} />
            <FormControlLabel value="0" disabled control={<NeutralMood />} />
            <FormControlLabel value="-1" disabled control={<SadMood />} />
          </RadioGroup>
        )}
      </div>
    </div>
  );
}
